export default __webpack_public_path__ + "static/media/frog_R2_C2.f1b1fcf3.png";